import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { ButtonBase, Checkbox, Grid } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import AppDialog from "../../components/Common/AppDialog.js";
import AppTab from "../../components/Common/AppTab.js";
import Label from "../../components/Common/Label.js";
import LoadingDialog from "../../components/Common/LoadingDialog.js";
import Notification from "../../components/Common/Notification.js";
import PopOverFilter from "../../components/Common/PopoverFilter";
import SearchBar from "../../components/Common/Searchbar.js";
import Table from "../../components/Common/Table.js";
import TablePageControl from "../../components/Common/TablePageControl.js";
import Toggle from "../../components/Common/Toggle.js";
import CustomButton from "../../components/Form/CustomButton.js";
import CustomSelect2 from "../../components/Form/CustomSelect2.js";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton.js";
import Helpers from "../../helpers/helpers.js";
import { bulkUpdateAdvert, changeSidebarType, deleteAdvert, getAdvertListing, resetAdvertActionState, resetAdvertState, updateAdvert } from "../../store/actions.js";
import AppealModal from "./modal/AppealModal.js";
import MarkReserved from "./modal/MarkReserved.js";
import MarkSold from "./modal/MarkSold.js";
import MoveDraft from "./modal/MoveDraft.js";
import MoveToHidden from "./modal/MoveToHidden.js";
import PublishAdvert from "./modal/PublishAdvert.js";
import RenewAdvert from "./modal/RenewAdvert.js";
import RevertStatus from "./modal/RevertStatus.js";

const Advert = ({ userPermission, advertListing, leftSideBarType, editAdvert, advertDelete, width, makeList, modelList, bikeTypeList, editAdvertFeatured, licenseCategoryList, isDirectSeller }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetAdvertState());
        if (width <= 768) {
            dispatch(changeSidebarType("condensed", true));
        }

    }, []);

    const [loading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [tabValue, setTabValue] = useState('all');
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("10");
    const [search, setSearch] = useState("");
    const [sort, setSorted] = useState("desc");
    const [sort_by, setSortBy] = useState("id");
    const [selectedIds, setSelectedIds] = useState();
    const [selectedRow, setSelectedRow] = useState([]);
    const [soldOpen, setSoldOpen] = useState(false);
    const [reservedOpen, setReservedOpen] = useState(false);
    const [publishOpen, setPublishOpen] = useState(false);
    const [renewOpen, setRenewOpen] = useState(false);
    const [moveDraftOpen, setMoveDraftOpen] = useState(false);
    const [moveToHiddenOpen, setMoveToHiddenOpen] = useState(false);
    const [revertStatusOpen, setRevertStatusOpen] = useState(false);
    const [revertStatus, setRevertStatus] = useState(false);
    const [startSelecting, setStartSelecting] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [appealOpen, setAppealOpen] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [exportable, setExportable] = useState(true);
    const [creatable, setCreatable] = useState(true);
    const [editable, setEditable] = useState(true);
    const [deletable, setDeletable] = useState(true);
    const [showAll, setShowAll] = useState(false);
    const itemsToShow = showAll ? selectedRow : selectedRow.slice(0, 2);
    const searchRef = useRef(search);

    //filter
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [filterObject, setFilterObject] = useState({ position: 'all', status: 'all', bannerType: 'all', advert_type: ["all"], make: [], model: [], bike_type: [], licenseCategory: [] });


    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-marketing") && setCreatable(true);
            userPermission?.includes("edit-marketing") && setEditable(true);
            userPermission?.includes("delete-marketing") && setDeletable(true);
            userPermission?.includes("export-marketing") && setExportable(true);
        }
    }, [userPermission]);

    useEffect(() => {
        initData();
    }, [length, page, sort, sort_by]);

    useEffect(() => {
        searchRef.current = search || '';
    }, [search]);

    useEffect(() => {
        if (advertListing?.data) {
            setIsLoading(false);
        }
    }, [advertListing]);

    useEffect(() => {
        if (editAdvert?.code === 'success' || editAdvertFeatured?.code === 'success') {
            setNotification({
                open: true,
                type: 'success',
                msg: editAdvertFeatured?.message || 'Advert updated successfully.'
            });
            initData();

            moveDraftOpen && setMoveDraftOpen(false);
            revertStatusOpen && setRevertStatusOpen(false);
            publishOpen && setPublishOpen(false);
            renewOpen && setRenewOpen(false);
            soldOpen && setSoldOpen(false);
            reservedOpen && setReservedOpen(false);
            moveToHiddenOpen && setMoveToHiddenOpen(false);
            appealOpen && setAppealOpen(false);

            selectedIds && setSelectedIds([]);
            selectedRow && setSelectedRow([]);
            dispatch(resetAdvertActionState());
        }
    }, [editAdvert, editAdvertFeatured])

    useEffect(() => {
        if (advertDelete?.code === 'success') {
            setDeleteOpen(false);
            setNotification({ open: true, msg: advertDelete?.message || 'Advert deleted successfully', type: 'success' });
            setSelectedIds([]);
            setSelectedRow([]);
            initData();
            dispatch(resetAdvertActionState());
        }
    }, [advertDelete])

    useEffect(() => {
        if (checkedAll) {
            let temp = advertListing && advertListing?.data?.data?.length > 0 ? advertListing?.data?.data?.map((x, idx) => x?.id) : []
            setSelectedIds(temp)
            setSelectedRow(advertListing?.data?.data || [])
        } else {
            setSelectedIds([])
            setSelectedRow([])
        }

    }, [checkedAll]);

    // useEffect(() => {
    //     const data = Array.isArray(advertListing?.data?.data) &&
    //         advertListing.data.data.length > 0 &&
    //         Array.isArray(selectedIds) &&
    //         advertListing.data.data.every((item) => selectedIds.includes(item?.id));
    //         console.log("data", data)
    //     setCheckedAll(data);


    // }, [page]);

    const draftDropdownList = [
        { iconName: 'solar:upload-minimalistic-linear', label: 'Publish Selected', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('publish') } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const pendingApprovalDropdownList = [
        // { iconName: 'solar:archive-down-minimlistic-linear', label: 'Move to Draft', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('move_to_draft') } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const publishedDropdownList = [
        { iconName: 'fluent:door-tag-20-regular', label: 'Mark as Reserved', permission: editable, onClick: () => { handleActionClick('reserve') } },
        { iconName: 'solar:check-read-linear', label: 'Mark as Sold', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('mark_as_sold') } },
        { iconName: 'solar:refresh-linear', label: 'Renew Selected', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('renew') } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('hidden') } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const reservedDropdownList = [
        { iconName: 'solar:undo-left-round-linear', label: 'Revert to Published', permission: deletable, onClick: () => { setRevertStatus('published'); handleActionClick('revert_status') } },
        { iconName: 'solar:check-read-linear', label: 'Mark as Sold', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('mark_as_sold') } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('hidden') } },

        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const soldDropdownList = [
        { iconName: 'solar:undo-left-round-linear', label: 'Revert to Published', permission: deletable, onClick: () => { setRevertStatus('published'); handleActionClick('revert_status') } },
        { iconName: 'fluent:door-tag-20-regular', label: 'Mark as Reserved', permission: editable, onClick: () => { handleActionClick('reserve') } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('hidden') } },

        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const expiredDropdownList = [
        { iconName: 'solar:refresh-linear', label: 'Renew Selected', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('renew') } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('hidden') } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const appealedDropdownList = [
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const rejectedDropdownList = [
        { iconName: 'ri-draft-line', label: 'Appeal Selected', permission: true, onClick: () => { handleActionClick("appeal") } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const hiddenDropdownList = [
        { iconName: 'solar:undo-left-round-linear', label: 'Revert to Published', permission: deletable, onClick: () => { setRevertStatus('published'); handleActionClick('revert_status') } },
        { iconName: 'fluent:door-tag-20-regular', label: 'Mark as Reserved', permission: editable, onClick: () => { handleActionClick('reserve') } },
        { iconName: 'solar:check-read-linear', label: 'Mark as Sold', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('mark_as_sold') } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const handleActionClick = (action) => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to perform this action.' });
            return;
        }
        switch (action) {
            case 'mark_as_sold':
                setSoldOpen(true);
                break;
            case 'renew':
                setRenewOpen(true);
                break;
            case 'publish':
                setPublishOpen(true);
                break;
            case 'move_to_draft':
                setMoveDraftOpen(true);
                break;
            case 'reserve':
                setReservedOpen(true);
                break;
            case 'hidden':
                setMoveToHiddenOpen(true);
                break;
            case 'revert_status':
                setRevertStatusOpen(true);
                break;
            case 'delete':
                setDeleteOpen(true);
                break;
            case 'appeal':
                setAppealOpen(true);
                break;

        }
    }

    const vehicleStatusList = [
        { label: 'New', value: 'new', color: '#2C7F41' },
        { label: 'Used', value: 'used', color: '#FF8D28' },
        { label: 'Rental', value: 'rental', color: '#475A99' },
    ]
    const isAllAdvertSelected =
        Array.isArray(advertListing?.data?.data) &&
        advertListing.data.data.length > 0 &&
        Array.isArray(selectedIds) &&
        advertListing.data.data.every((item) => selectedIds.includes(item?.id));

    const deleteCheckBox = [
        {
            Header: "#",
            accessor: (cellProps) => {
                return (
                    <div className="text-center" onClick={(e) => e.stopPropagation()}>
                        <Checkbox
                            checked={selectedIds && selectedIds?.length > 0 && selectedIds?.includes(cellProps.id)}
                            checkedIcon={Helpers.checkIcon()}
                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                            sx={{
                                '&.Mui-checked': {
                                    color: "#a0a0a0",
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: 18,
                                },
                            }}
                            value={cellProps.id}
                            onChange={(event) => { handleCheckboxChange(event.target.value, cellProps) }} />
                    </div>
                )
            },
        },
    ]

    const header = [
        {
            Header: "Listing",
            columnID: "title",
            minWidth: 300,
            accessor: (cellProps) => {
                const statusObj = vehicleStatusList.find(item => item.value === cellProps?.bike_advert_type);
                return (
                    <div className="d-flex align-items-center">
                        <div style={{ marginRight: 10 }}>
                            <img src={cellProps?.base64 || Helpers.noImage} alt="vehicle" style={{ width: 45, objectFit: 'contain' }} />
                        </div>
                        <div >
                            <div className="text-bold">{cellProps?.info?.title || '-'}</div>
                            <div className="subheader-2 font-size-12 align-items-center d-flex">
                                <span style={{ color: statusObj?.color }}>{statusObj?.label || "-"}</span>
                                {cellProps?.info?.register_number && <>
                                    <span style={{ color: '#A0A0A0', fontSize: '18px', margin: '0 8px' }}>&bull;</span>
                                    <span>{cellProps?.info?.register_number || "-"}</span>
                                </>}
                            </div>
                        </div>
                    </div>
                )
            },
        },
        {
            Header: "Price",
            columnID: "price",
            minWidth: 150,
            accessor: (cellProps) => {
                return (
                    <>
                        {
                            cellProps?.bike_advert_type === 'rental' ?
                                <>
                                    <div className="text-bold">${cellProps?.rental_rate?.daily_rate_formatted || "0"}</div>
                                    <div className="subheader-2 font-size-12">{"Daily rate"}</div>
                                </> :
                                <>
                                    {/* <div className="text-bold">${(cellProps?.pricing?.pricing_type === 4 ? cellProps?.pricing?.selling_price : cellProps?.pricing?.pricing_type === 3 ? cellProps?.pricing?.promotion_price : cellProps?.pricing?.pricing_type === 2 ? cellProps?.pricing?.min_downpayment : cellProps?.pricing?.machine_price) || "0"}</div> */}
                                    <div className="text-bold">{(cellProps?.price || "0")}</div>
                                    <div className="subheader-2 font-size-12">
                                        {cellProps?.bike_advert_type?.toLowerCase() === 'new' &&
                                            (Number(cellProps?.pricing?.pricing_type) === 1 || cellProps?.pricing?.pricing_type_name?.toLowerCase() === 'machine price')
                                            ? 'OTR Price'
                                            : cellProps?.pricing?.pricing_type_name || "-"}
                                    </div>
                                </>
                        }
                    </>
                )
            },
        },
        {

            Header: "Expires On",
            columnID: "expired_date",
            minWidth: 150,
            accessor: (cellProps) => {
                return (
                    <div className="d-flex align-items-center">
                        {cellProps?.expired_date || "-"}
                        {
                            cellProps?.is_near_expiry === 1 &&
                            <Icon
                                icon={'solar:danger-triangle-bold'}
                                style={{ color: '#FFCD71', marginLeft: '5px', width: 16, height: 16 }}
                            />
                        }
                    </div>
                )
            },
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (cellProps?.status ? <Label.GeneralStatusLabel label={cellProps.status} list={Helpers.advertStatus} marginLeft={"0px"} /> : "-")
            },
        },
        {
            Header: "Featured",
            accessor: (cellProps) => {
                return (
                    <div onClick={(e) => e.stopPropagation()}><Toggle checked={cellProps?.is_featured || false} onChange={(e) => { e.stopPropagation(); handleFeaturedChangeValue(cellProps) }} /></div>
                )
            },
        },
    ]

    const tabList = [
        { value: 'draft', label: `Draft (${advertListing?.counts?.draft || 0})` },
        { value: 'published', label: `Published (${advertListing?.counts?.published || 0})` },
        { value: 'reserved', label: `Reserved (${advertListing?.counts?.reserved || 0})` },
        { value: 'sold', label: `Sold (${advertListing?.counts?.sold || 0})` },
        { value: 'expired', label: `Expired (${advertListing?.counts?.expired || 0})` },
        { value: 'hidden', label: `Hidden (${advertListing?.counts?.hidden || 0})` },
        { value: 'all', label: `All (${advertListing?.counts?.all || 0})` },
    ];

    const initData = () => {
        setIsLoading(true);
        dispatch(getAdvertListing({
            page: page,
            length: length,
            sort: sort,
            sort_by: sort_by,
            search: searchRef.current,
            tab: tabValue,
            bike_advert_type: filterObject?.advert_type?.length > 0 ? filterObject?.advert_type?.filter(item => item !== "all") : [],
            bike_make_ids: filterObject?.make || [],
            bike_model_ids: filterObject?.model || [], bike_types: filterObject?.bike_types || [],
            // vehicle_source: filterObject?.license_category || [],
            price_range_from: filterObject?.min_price || "",
            price_range_to: filterObject?.max_price || "",
            created_at_from: filterObject?.from ? moment(filterObject?.from, "DD/MM/YYYY")?.format?.("YYYY/MM/DD") : "",
            created_at_to: filterObject?.to ? moment(filterObject?.to, "DD/MM/YYYY")?.format?.("YYYY/MM/DD") : "",
            license_category_ids: filterObject?.license_category || [],
        }))
    }

    const resetFilter = () => {
        setFilterObject({ status: "all", advert_type: ['all'], make: [], model: [], bike_type: [], licenseCategory: [] });
        setStartDate("");
        setEndDate("");
        setSearch(""); // Clear search keyword
        searchRef.current = ""; // Update searchRef
        setPage(page === 1 ? '1' : 1);
    }

    const handleFilterChange = (key, value) => {
        setFilterObject((prevValues) => ({
            ...prevValues,
            [key]: value,
        }));
        setPage((prevPage) => (prevPage === 1 ? '1' : 1));
    };

    const filterList2 = [
        {
            label: "Advert Type",
            type: "checkbox",
            value: filterObject?.advert_type || [],
            data: Helpers.advertTypeList,
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    advert_type: e,
                }))
            }
        },
        {
            label: "Make",
            type: "checkbox",
            value: filterObject?.make || [],
            data: makeList || [],
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    make: e,
                }))
            }
        },
        {
            label: "Model",
            type: "checkbox",
            value: filterObject?.model || [],
            data: modelList || [],
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    model: e,
                }))
            }
        },
        {
            label: "Body Type",
            type: "checkbox",
            value: filterObject?.bike_types || [],
            data: bikeTypeList || [],
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    bike_types: e,
                }))
            }
        },
        {
            label: "Price Range",
            type: "priceRange",
            minValue: filterObject?.min_price || "",
            maxValue: filterObject?.max_price || "",
            prefix: "$",
            setMinAmount: (value) => {
                setFilterObject({ ...filterObject, min_price: value })
            },
            setMaxAmount: (value) => {
                setFilterObject({ ...filterObject, max_price: value })
            },
        },
        {
            label: "License Category",
            type: "checkbox",
            value: filterObject?.license_category || [],
            data: licenseCategoryList || [],
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    license_category: e,
                }))
            }
        },
        {
            label: "Created Date",
            value: filterObject?.createdDate,
            type: "date_range",
            startPlaceholder: "From",
            endPlaceholder: "To",
            startDateTitle: "From",
            startDate: startDate,
            setStartDate: (date) => {
                setStartDate(date);
                const formattedDate = date ? moment(date).format('DD/MM/YYYY') : "";
                setFilterObject((prev) => ({ ...prev, from: formattedDate }));
            },
            endDateTitle: "To",
            endDate: endDate,
            setEndDate: (date) => {
                setEndDate(date);
                const formattedDate = date ? moment(date).format('DD/MM/YYYY') : "";
                setFilterObject((prev) => ({ ...prev, to: formattedDate }));
            },
            xsGrid: 12, smGrid: 12, mdGrid: 12
        },
    ]

    const applyFilter = (sort, sortBy) => {
        setSortBy(sortBy || 'id');
        setSorted(sort || 'desc');
        setPage(page === 1 ? '1' : 1);
        setDrawerOpen(false);
    }

    const handleCheckboxChange = (e, item) => {
        let temp = [];
        let tempItem = [];
        if (selectedIds && selectedIds?.includes(parseInt(e))) {
            temp = selectedIds.filter((x) => x !== parseInt(e)).map((y) => y);
            tempItem = selectedRow.filter((x) => x.id !== parseInt(e)).map((y) => y);
            setSelectedRow(tempItem)
            setSelectedIds(temp)
        } else {
            setSelectedIds([...selectedIds, parseInt(e)])
            setSelectedRow([...selectedRow, item])
        }
    }

    const handleFeaturedChangeValue = (rowData) => {
        setIsLoading(true);
        dispatch(updateAdvert({
            id: rowData?.id,
            data: { action: "toggle_feature", is_featured: rowData?.is_featured === 1 ? 0 : 1 }
        }));
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage(page === 1 ? '1' : 1);
            }
        }, Helpers.searchInterval);
    }

    const handleDelete = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to delete.' });
            return;
        }
        setIsLoading(true);
        dispatch(deleteAdvert({ ids: selectedIds }));
    }

    const handleMarkAsSold = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to mark as sold.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: 'sold'
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleAppeal = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to appeal.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: 'appealed'
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleMarkAsReserved = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to reserve.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: 'reserved'
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleRenewAdvert = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to renew.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'renew_plan',
            ids: selectedIds,
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handlePublish = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to publish.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: 'published'
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleMoveToDraft = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to move to draft.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: 'draft'
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleMoveToHidden = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to move to hidden.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: 'hidden'
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleRevertStatus = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to revert.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: revertStatus
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleTabChange = (value) => {
        setTabValue(value);
        setPage(page === 1 ? '1' : 1);
        // setStartSelecting(false);
        setCheckedAll(false);
        setSelectedIds([]);
        setSelectedRow([]);
    }

    const filterList = [
        { label: 'All', value: 'all' },
        { label: 'New Motorcycle', value: 'new' },
        { label: 'Used Motorcycle', value: 'used' },
        { label: 'For Rent', value: 'rental' },
    ]

    const dropdownList = tabValue === 'draft' ? draftDropdownList : tabValue === 'published' ? publishedDropdownList : tabValue === 'reserved' ? reservedDropdownList : tabValue === 'sold' ? soldDropdownList : tabValue === 'hidden' ? hiddenDropdownList : tabValue === 'appealed' ? appealedDropdownList : tabValue === 'rejected' ? rejectedDropdownList : expiredDropdownList;

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={9} md={12} style={{ display: 'flex', alignItems: "center" }} spacing={1}>
                    <Grid item lg={4} md={4} xs={12}>
                        <SearchBar
                            value={search}
                            module={'make, model, title, or reg. no'}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item className="d-flex mt-1">
                        <CustomSelect2
                            module={'Type'}
                            values={filterObject?.advert_type?.[0] || '-1'}
                            data={filterList}
                            placeholder={'All'}
                            onChange={(e) => handleFilterChange('advert_type', [e])}
                            startAdornment={<div className="subheader-2" style={{ marginRight: 5 }}>Type: </div>}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}>
                        <PopOverFilter
                            setDialogOpen={setDrawerOpen}
                            open={drawerOpen}
                            applyFilter={applyFilter}
                            filterData={filterList2}
                            setFilterObject={setFilterObject}
                            sort={sort} sort_by={sort_by}
                            handleResetFilter={resetFilter}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}>
                        <CustomButton
                            title={<div style={{ textDecorationLine: 'underline' }}>Clear all</div>}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#B48A3C'}
                            borderStyle={'none'}
                        />
                    </Grid>
                </Grid>
                {
                    tabValue !== 'all' &&
                    <Grid item lg={3} md={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }} alignItems={'center'}>
                        <CustomButton
                            title={'Select'}
                            press={() => setStartSelecting(!startSelecting)}
                            height={32}
                            backgroundColor={startSelecting ? '#F5F5F5' : 'white'}
                            textColor={'#000'}
                            borderStyle={startSelecting ? "1px solid #E3E8EE" : "1px solid #babcbe"}
                            marginRight={startSelecting ? 5 : 0}
                        />
                        {
                            startSelecting &&
                            <RenderPopOverButton
                                items={dropdownList}
                                customTitle={
                                    <CustomButton
                                        title={<>Bulk Actions<Icon icon={'fluent:chevron-down-20-regular'} style={{ marginLeft: 10, color: '#525252CC' }} /></>}
                                        press={() => { }}
                                        height={32}
                                        backgroundColor={'white'}
                                        textColor={'#000'}
                                        borderStyle={"1px solid #babcbe"}
                                    />
                                }
                            />
                        }

                    </Grid>
                }
            </Grid>
        )
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center p-1 pb-2">
                <div className="header-2 d-flex align-items-center">Listing <div className="header-amount mx-2">{advertListing?.data?.total || 0}</div></div>
                {
                    creatable &&
                    <CustomButton
                        title={<><i className="ri-add-line" style={{ marginRight: '5px' }} />Create new ad</>}
                        borderStyle={'1px solid #101010'}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        press={() => navigate('/add-advert')}
                        padding={20}
                    />
                }
            </div>
        )
    }

    const mobileView = () => {
        return (
            <div>
                <AppTab tabValue={tabValue} setTabValue={handleTabChange}
                    tabList={
                        isDirectSeller
                            ? [
                                ...tabList.slice(0, -1), // Everything except the last 2 items
                                {
                                    value: "appealed",
                                    label: `Appealed (${advertListing?.counts?.appealed || 0})`,
                                },
                                {
                                    value: "rejected",
                                    label: `Rejected (${advertListing?.counts?.rejected || 0})`,
                                },
                                ...tabList.slice(-1), // Last 2 items
                            ]
                            : tabList
                    }
                />
                <div className="d-flex justify-content-between align-items-center p-1 pb-2">
                    <div className="d-flex align-items-cente text-semibold font-size-16">{advertListing?.data?.total || 0} Listings</div>
                    <ButtonBase style={{ borderRadius: '100%' }} onClick={() => navigate('/add-advert')}>
                        <Icon icon={'ri:add-circle-fill'} style={{ height: 28, width: 28 }} />
                    </ButtonBase>
                </div>
                <div className="mt-1 mb-2">
                    <SearchBar
                        value={search}
                        module={'make, model, title, or reg. no'}
                        setValue={(e) => handleSearch(e)}
                    />
                </div>


                <div className="d-flex align-items-center my-3 gap-2" style={{ flexWrap: 'wrap' }}>
                    {
                        tabValue !== 'all' && <>
                            <CustomButton
                                title={'Select'}
                                press={() => setStartSelecting(!startSelecting)}
                                height={32}
                                backgroundColor={startSelecting ? '#F5F5F5' : 'white'}
                                textColor={'#000'}
                                borderStyle={startSelecting ? "1px solid #E3E8EE" : "1px solid #babcbe"}
                                marginRight={5}
                            />
                            {
                                startSelecting &&
                                <RenderPopOverButton
                                    items={dropdownList}
                                    customTitle={
                                        <CustomButton
                                            title={<>Bulk Actions<Icon icon={'fluent:chevron-down-20-regular'} style={{ marginLeft: 10, color: '#525252CC' }} /></>}
                                            press={() => { }}
                                            height={32}
                                            backgroundColor={'white'}
                                            textColor={'#000'}
                                            borderStyle={"1px solid #babcbe"}
                                            marginRight={5}
                                            width={150}
                                        />
                                    }
                                />
                            }
                        </>}
                    <PopOverFilter
                        setDialogOpen={setDrawerOpen}
                        open={drawerOpen}
                        applyFilter={applyFilter}
                        filterData={filterList2}
                        setFilterObject={setFilterObject}
                        sort={sort} sort_by={sort_by}
                        handleResetFilter={resetFilter}
                    />
                </div>

                {
                    Array.isArray(advertListing?.data?.data) && advertListing?.data?.data.length > 0 && advertListing?.data?.data.map((item) => {
                        const statusObj = vehicleStatusList.find(x => x.value === item?.bike_advert_type);
                        return (
                            <div className="d-flex align-items-center py-2" style={{ borderBottom: '1px solid #E2E2E2' }} onClick={() => navigate(`/advert/${item?.id}`)}>
                                {
                                    startSelecting &&
                                    <div className="text-center" onClick={(e) => e.stopPropagation()}>
                                        <Checkbox
                                            checked={selectedIds && selectedIds?.length > 0 && selectedIds?.includes(item.id)}
                                            checkedIcon={Helpers.checkIcon()}
                                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                                            sx={{
                                                '&.Mui-checked': {
                                                    color: "#a0a0a0",
                                                },
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 18,
                                                },
                                            }}
                                            value={item.id}
                                            onChange={(event) => { handleCheckboxChange(event.target.value, item) }} />
                                    </div>
                                }
                                <div style={{ marginRight: 10 }}>
                                    <img src={item?.base64 || Helpers.noImage} alt="vehicle" style={{ width: 45, objectFit: 'contain' }} />
                                </div>
                                <div >
                                    <div className="text-bold">{item?.info?.title || "-"}</div>
                                    <div className="align-items-center d-flex gap-1">
                                        <span style={{ color: statusObj?.color }}>{statusObj?.label || "-"}</span>
                                        <Label.GeneralStatusLabel label={item.status} list={Helpers.advertStatus} marginLeft={"0px"} />
                                        <div className="mx-2 text-semibold">${item?.pricing?.price_formatted || item?.rental_rate?.daily_rate_formatted || "-"}</div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }

            </div>
        )
    }

    const getHeader = () => {
        let data = {
            Header: "HP Application",
            minWidth: 300,
            accessor: (cellProps) => {
                return (
                    <Grid container spacing={2}>
                        <Grid item sm={4}>
                            <div className="text-bold">{cellProps?.loan_application_counts?.submitted || "0"}</div>
                            <div className="subheader-2 font-size-12">Submitted</div>
                        </Grid>
                        <Grid item sm={4}>
                            <div className="text-bold">{cellProps?.loan_application_counts?.approved || "0"}</div>
                            <div className="subheader-2 font-size-12">Approved</div>
                        </Grid>
                        <Grid item sm={4}>
                            <div className="text-bold">{cellProps?.loan_application_counts?.rejected || "0"}</div>
                            <div className="subheader-2 font-size-12">Rejected</div>
                        </Grid>
                    </Grid>
                )
            },
        }
        if (!isDirectSeller) {
            const tempHeader = [...header];
            tempHeader.splice(2, 0, data);
            return tempHeader;
        }
        return header;
    }

    const handleCheckedAll = () => {
        if (isAllAdvertSelected) {
            const selectedRemoveRow = advertListing?.data?.data || [];
            const selectedRemoveIds = selectedRemoveRow.map((item) => item.id);
            setSelectedIds(selectedIds.filter(id => !selectedRemoveIds.includes(id)));
            setSelectedRow(selectedRow.filter(row => !selectedRemoveRow.some(item => item.id === row.id)));
        } else {
            const currentSelectedIds = Array.isArray(selectedIds) ? selectedIds : [];
            const currentSelectedRows = Array.isArray(selectedRow) ? selectedRow : [];
            const existingIdSet = new Set(currentSelectedIds);
            const incomingRows = advertListing?.data?.data || [];
            const newRows = incomingRows.filter((item) => !existingIdSet.has(item?.id));
            const newIds = newRows
                .map((item) => item?.id)
                .filter((id) => id !== undefined && id !== null);

            setSelectedIds([...currentSelectedIds, ...newIds]);
            setSelectedRow([...currentSelectedRows, ...newRows]);
        }
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: width <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading || !advertListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    {
                        width <= 768 ? mobileView() :
                            <>
                                {renderHeader()}
                                <AppTab tabValue={tabValue} setTabValue={handleTabChange}
                                    tabList={
                                        isDirectSeller
                                            ? [
                                                ...tabList.slice(0, -1), // Everything except the last 2 items
                                                {
                                                    value: "appealed",
                                                    label: `Appealed (${advertListing?.counts?.appealed || 0})`,
                                                },
                                                {
                                                    value: "rejected",
                                                    label: `Rejected (${advertListing?.counts?.rejected || 0})`,
                                                },
                                                ...tabList.slice(-1), // Last 2 items
                                            ]
                                            : tabList
                                    }
                                />
                                {customToolsBar()}
                                <Table
                                    header={startSelecting ? [...deleteCheckBox, ...getHeader()] : getHeader()}
                                    data={advertListing?.data?.data || []}
                                    pageSize={length}
                                    totalPage={advertListing?.data?.last_page || 1}
                                    customToolsBar={true}
                                    sort={sort}
                                    setSorted={setSorted}
                                    sort_by={sort_by}
                                    setSortBy={setSortBy}
                                    setCheckedAll={handleCheckedAll}
                                    checkedAll={isAllAdvertSelected}
                                    onTableRowClick={(row) => navigate(`/advert/${row?.id}`)}
                                />
                            </>
                    }

                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={advertListing?.data?.last_page || 1}
                    />
                    <MarkSold
                        open={soldOpen}
                        close={() => setSoldOpen(false)}
                        handleSubmit={() => { handleMarkAsSold() }}
                        windowWidth={width}
                        isBulkAction={true}
                        selectedItems={selectedRow}
                    />
                    <PublishAdvert
                        open={publishOpen}
                        close={() => setPublishOpen(false)}
                        handleSubmit={() => { handlePublish() }}
                        windowWidth={width}
                        isDirectSeller={isDirectSeller}
                        isBulkAction={true}
                        selectedItems={selectedRow}
                    />
                    <MarkReserved
                        open={reservedOpen}
                        close={() => setReservedOpen(false)}
                        handleSubmit={() => { handleMarkAsReserved() }}
                        isBulkAction={true}
                        selectedItems={selectedRow}
                        windowWidth={width}
                    />
                    <RenewAdvert
                        open={renewOpen}
                        close={() => setRenewOpen(false)}
                        handleSubmit={() => { handleRenewAdvert() }}
                        advertData={{ remaining_boosts: 2 }}
                        isBulkAction={true}
                        selectedItems={selectedRow}
                        windowWidth={width}
                    />
                    <MoveDraft
                        open={moveDraftOpen}
                        close={() => setMoveDraftOpen(false)}
                        handleSubmit={() => { handleMoveToDraft() }}
                        isBulkAction={true}
                        selectedItems={selectedRow}
                        windowWidth={width}
                    />
                    <MoveToHidden
                        open={moveToHiddenOpen}
                        close={() => setMoveToHiddenOpen(false)}
                        handleSubmit={() => { handleMoveToHidden() }}
                        isBulkAction={true}
                        selectedItems={selectedRow}
                        windowWidth={width}
                    />
                    <AppealModal
                        isBulkAction={true}
                        open={appealOpen}
                        isDirectSeller={isDirectSeller}
                        selectedItems={selectedRow}
                        close={() => setAppealOpen(false)}
                        handleSubmit={() => { handleAppeal() }}
                        windowWidth={width}
                    />
                    <RevertStatus
                        open={revertStatusOpen}
                        close={() => setRevertStatusOpen(false)}
                        handleSubmit={() => { handleRevertStatus() }}
                        isBulkAction={true}
                        selectedItems={selectedRow}
                        windowWidth={width}
                        revertStatus={revertStatus}
                    />
                    <AppDialog
                        open={deleteOpen}
                        close={() => setDeleteOpen(false)}
                        title={`Delete Selected Advert`}
                        positiveTitle={'Delete'}
                        positiveButtonStyle={{ backgroundColor: '#D13536', color: 'white', borderRadius: 20, width: 'auto', border: '1px solid #D13536' }}
                        positivePress={() => handleDelete()}
                        cancelButton={true}
                        width={'40%'}
                        windowWidth={width}
                    >
                        <div>Are you sure you want to delete {selectedRow.length} selected advert(s)?</div>
                        <ol style={{ paddingInline: 20, paddingBlock: 10 }}>
                            {itemsToShow?.map((item, idx) => (
                                <li key={idx} className="mb-2 ">
                                    <div className="d-flex align-items-center">
                                        {item?.make?.name || '-'} {item?.model?.model_name || ''}
                                        <Label.GeneralStatusLabel label={item?.status || '-'} list={Helpers.advertStatus} marginLeft={"10px"} />
                                    </div>
                                </li>
                            ))}
                            {selectedRow.length > 2 && (
                                <div
                                    onClick={() => setShowAll(!showAll)}
                                    className="clickable underline"
                                    style={{ marginTop: '10px' }}
                                >
                                    {showAll ? 'Show less' : 'Show more'}
                                </div>
                            )}
                        </ol>
                        <div className="my-2">Once deleted:</div>
                        <ul className="subheader-2" style={{ padding: 5, paddingInline: 15 }}>
                            <li className="mb-2">The adverts will be permanently removed from the marketplace.</li>
                            <li className="mb-2">Enquiries and performance data for the selected adverts will be lost.</li>
                        </ul>
                    </AppDialog>
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Advert, Layout, General }) {
    return {
        width: Layout?.currentWidth,
        isDirectSeller: Login?.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,
        userPermission: Login.permissionArry,
        advertListing: Advert?.advertListing,
        leftSideBarType: Layout.leftSideBarType,
        editAdvert: Advert?.advertBulkEdit,
        editAdvertFeatured: Advert?.advertEdit,
        advertDelete: Advert?.advertDelete,
        makeList: General.bike_makes?.map((x, idx) => ({
            label: x.name,
            value: x.id
        })) || [],
        modelList: General.bike_models?.map((x, idx) => ({
            label: x.name,
            value: x.id
        })) || [],
        bikeTypeList: General.bike_types?.map((x, idx) => ({
            label: x.name,
            value: x.id
        })) || [],
        licenseCategoryList: General.license_categories?.map((x, idx) => ({
            label: x.name,
            value: x.id
        })) || [],
    };
}

export default connect(mapStateToProps)(Advert);
